'use strict';

import Alt from 'alt';

// Stores
import AppStore from 'stores/appStore';
import TranslationsStore from 'stores/translationsStore';
import MediaStore from 'stores/mediaStore';
import ModalStore from 'stores/modalStore';
import BasketStore from 'stores/basketStore';
import NotificationStore from 'stores/notificationStore';
import RequestStore from 'stores/requestStore';
import ShareStore from 'stores/shareStore';

// Actions
import AppActions from 'actions/appActions';
import TranslationsActions from 'actions/translationsActions';
import MediaActions from 'actions/mediaActions';
import ModalActions from 'actions/modalActions';
import BasketActions from 'actions/basketActions';
import NotificationActions from 'actions/notificationActions';
import RequestActions from 'actions/requestActions';
import ShareActions from 'actions/shareActions';

class Flux extends Alt {
    constructor(config = {}) {
        super(config);

        // Register Actions
        this.addActions('app', AppActions);
        this.addActions('translations', TranslationsActions);
        this.addActions('media', MediaActions);
        this.addActions('modals', ModalActions);
        this.addActions('basket', BasketActions);
        this.addActions('notifications', NotificationActions);
        this.addActions('requests', RequestActions);
        this.addActions('share', ShareActions);

        // Register Stores
        this.addStore('app', AppStore);
        this.addStore('translations', TranslationsStore);
        this.addStore('media', MediaStore);
        this.addStore('modals', ModalStore);
        this.addStore('basket', BasketStore);
        this.addStore('notifications', NotificationStore);
        this.addStore('requests', RequestStore);
        this.addStore('share', ShareStore);
    }

    t(path = false) {
        if (path) {
            return this.stores.translations.getIntlMessage(path);
        } else {
            return this.stores.translations;
        }
    }

    getAppConfig() {
        return this.stores.app.getState().config.toJS();
    }
}
// we export a new instance, we don't do this in the index because
// we don't really care about singletons and server-side-rendering
// when MSP decides to render js on the server, we have to revisit this
export default new Flux();



// WEBPACK FOOTER //
// ./app/utils/flux.js